module.exports = __webpack_public_path__ + "static/media/agenda-form.71d15257.svg";